import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Default from '../layouts/Default'
import Auth from '../layouts/Auth'
import Resolve from '@/views/Resolve.vue'
import Login from '@/views/auth/Login.vue'
import RegisterFromInvite from '@/views/auth/RegisterFromInvite.vue'
import Impersonate from '@/views/auth/Impersonate.vue'
import { TokenService } from '@/services/storage.service'
import EnterTheGame from '@/views/EnterTheGame.vue'
import PreGame from '@/views/PreGame.vue'
import LiveRoster from '@/views/LiveRoster.vue'
import Live from '@/views/live/Live.vue'
import Archive from '@/views/Archive.vue'
import ScorekeeperLiveLayout from '@/layouts/ScorekeeperLiveLayout.vue'
import ScorekeeperStopwatchLayout from '@/layouts/ScorekeeperStopwatchLayout.vue'
import ScorekeeperLayout from '@/layouts/ScorekeeperLayout.vue'
import MainLayout from '@/layouts/MainLayout.vue'
import Games from '@/views/Games.vue'
import LivestreamView from '@/views/LivestreamView.vue'
import { rememberRoute } from '@/use/useStartPage'
import StopwatchView from '@/views/StopwatchView.vue'
import Photos from '@/views/Photos.vue'
import PlayerPhotos from '@/views/PlayerPhotos.vue'
import GameGallery from '@/views/GameGallery.vue'

Vue.use(Router)

// A duplicated, redirected, cancelled or aborted navigation is expected (e.g. several
// logouts pushing the login route at once) and must not surface as an unhandled rejection.
const { isNavigationFailure, NavigationFailureType } = Router
const expectedNavigationFailures = [
  NavigationFailureType.duplicated,
  NavigationFailureType.redirected,
  NavigationFailureType.cancelled,
  NavigationFailureType.aborted
]

;['push', 'replace'].forEach(method => {
  const original = Router.prototype[method]

  Router.prototype[method] = function (location, onComplete, onAbort) {
    if (onComplete || onAbort) {
      return original.call(this, location, onComplete, onAbort)
    }

    return original.call(this, location).catch(error => {
      if (expectedNavigationFailures.some(type => isNavigationFailure(error, type))) {
        return error
      }

      throw error
    })
  }
})

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
      children: [
        {
          path: 'login',
          name: 'login',
          component: Login,
          meta: {
            public: true,
            onlyWhenLoggedOut: true
          }
        },
        {
          path: 'register-from-invite/:token',
          name: 'register-from-invite',
          component: RegisterFromInvite,
          meta: {
            public: true,
            onlyWhenLoggedOut: false
          }
        },
        {
          path: 'impersonate/:key',
          name: 'impersonate',
          component: Impersonate,
          meta: {
            public: true,
            onlyWhenLoggedOut: false
          }
        }
      ]
    },
    {
      path: '',
      name: 'mainLayout',
      component: MainLayout,
      children: [
        {
          path: '',
          name: 'panel',
          component: Default,
          beforeRouteUpdate: () => {
            store.commit('loaded')
          },
          children: [
            {
              path: '/',
              name: 'resolve',
              component: Resolve
            },
            {
              path: ':clientId',
              name: 'clientResolve',
              component: Resolve
            },
            {
              path: ':clientId/enter-the-game',
              name: 'enterTheGame',
              component: EnterTheGame
            },
            {
              path: ':clientId/games',
              name: 'games',
              component: Games
            },
            {
              path: ':clientId/livestream',
              name: 'livestream',
              component: LivestreamView
            },
            {
              path: ':clientId/photos',
              name: 'photos',
              component: Photos
            },
            {
              path: ':clientId/photos/:game',
              name: 'gameGallery',
              component: GameGallery
            },
            {
              path: ':clientId/player-photos',
              name: 'playerPhotos',
              component: PlayerPhotos
            }
          ]
        },
        {
          path: '',
          name: 'scorekeeper_stopwatch',
          component: ScorekeeperStopwatchLayout,
          beforeRouteUpdate: () => {
            store.commit('loaded')
          },
          children: [
            {
              path: ':clientId/games/:code/stopwatch',
              name: 'stopwatch',
              component: StopwatchView
            }
          ]
        },
        {
          path: '',
          name: 'scorekeeper',
          component: ScorekeeperLiveLayout,
          beforeRouteUpdate: () => {
            store.commit('loaded')
          },
          children: [
            {
              path: ':clientId/games/:code/pre-game',
              name: 'preGame',
              component: PreGame
            },
            {
              path: ':clientId/games/:code/roster',
              name: 'liveRoster',
              component: LiveRoster
            },
            {
              path: ':clientId/games/:code/live',
              name: 'live',
              component: Live
            }
          ]
        },
        {
          path: '',
          name: 'scorekeeper_archive',
          component: ScorekeeperLayout,
          beforeRouteUpdate: () => {
            store.commit('loaded')
          },
          children: [
            {
              path: ':clientId/games/:code/archive',
              name: 'archive',
              component: Archive
            }
          ]
        }
      ]
    }

  ],
  scrollBehavior () {
    const layoutId = document.getElementById('page-container')

    if (layoutId) {
      layoutId.scrollTo(0, 0)
    }
  }
})

router.beforeEach(async (to, from, next) => {
  // await store.dispatch('setClient', value)
  // eslint-disable-next-line
  jQuery('.modal').modal('hide')
  store.commit('loading')
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken()
  if (!isPublic && !loggedIn) {
    return next({
      name: 'login',
      query: { redirect: to.fullPath }
      // Store the full path to redirect the user to after login
    })
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  next()
})

router.afterEach((to) => {
  rememberRoute(to.name)
  // eslint-disable-next-line
  store.dispatch('closeNav')
  store.commit('loaded')
})

export default router
